import type TriggerEngine from "../../TriggerEngine";
import type { EventSourceResult } from "../../TriggerEngine.interfaces";

export const wireTimerEvents = (engine: TriggerEngine): EventSourceResult => {
  const timers = new Map<string, ReturnType<typeof setTimeout>>();

  const onStreamStarted = async () => {
    const rules = await engine.getRules();
    for (const rule of rules) {
      if (rule.event !== "timer_reached" || !rule.enabled) continue;
      const seconds = Number(rule.eventConfig?.seconds || 0);
      if (seconds <= 0) continue;

      const timer = setTimeout(() => {
        engine.executeAction(rule);
        timers.delete(rule.id);
      }, seconds * 1000);

      timers.set(rule.id, timer);
    }
  };

  const onStreamStopped = () => {
    for (const timer of timers.values()) clearTimeout(timer);
    timers.clear();
  };

  engine.Radio.Streaming.on("started", onStreamStarted);
  engine.Radio.Streaming.on("stopped", onStreamStopped);

  return {
    unsubscribers: [
      () => engine.Radio.Streaming.off("started", onStreamStarted),
      () => engine.Radio.Streaming.off("stopped", onStreamStopped),
    ],
    timers,
  };
};
